"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileOrTablet = exports.copyToClipboard = exports.openPopup = exports.encodedShareURL = exports.toQuery = void 0;

/* eslint-disable @typescript-eslint/no-explicit-any */
var toQuery = function toQuery(object) {
  var searchParams = Object.keys(object).map(function (k) {
    return object[k] ? encodeURIComponent(k) + '=' + encodeURIComponent(object[k]) : null;
  }).filter(function (e) {
    return e;
  }).join('&');
  return searchParams ? "?".concat(searchParams) : '';
};

exports.toQuery = toQuery;

var encodedShareURL = function encodedShareURL(url, utmParams) {
  return encodeURIComponent(url + toQuery(utmParams || {}));
};

exports.encodedShareURL = encodedShareURL;

var openPopup = function openPopup(url) {
  return window.open(url, 'sharer', 'toolbar=no,width=1042,height=436');
};

exports.openPopup = openPopup;

var copyToClipboard = function copyToClipboard(value) {
  var tempEl = document.createElement('textarea');
  tempEl.value = value;
  document.body.appendChild(tempEl);
  tempEl.select();
  var success = document.execCommand('copy');
  document.body.removeChild(tempEl);

  if (!success) {
    var locale = document.documentElement.lang || 'de';
    var alertMessage = locale === 'de' ? 'Sorry, dein Browser unterstützt diese Funktion nicht.' : "Sorry, your Browser doesn't support this feature.";
    alert(alertMessage);
  }

  return success;
};

exports.copyToClipboard = copyToClipboard;

var isMobileOrTablet = function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
};

exports.isMobileOrTablet = isMobileOrTablet;